import React from 'react';

import { useQueryState } from '@cvt/hooks/useQueryState';
import { useRouter } from '@cvt/hooks/useRouter';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';

import { FeedbackContext, LocalizationContext } from '@cvt/contexts';

import { AuthContext } from '../contexts/AuthContext';

export const Impersonate: React.FC = () => {

  const { dictionary } = React.useContext(LocalizationContext);
  const { triggerFeedback } = React.useContext(FeedbackContext);
  const { impersonate } = React.useContext(AuthContext);
  const router = useRouter();

  const [token] = useQueryState('token');

  const impersonateUser = React.useCallback(async (token: string) => {
    try {
      await impersonate(token);
      router.home.go();
    } catch {
      triggerFeedback({
        severity: 'error',
        message: dictionary.auth.impersonate.invalidToken,
      });
      router.auth.login.go();
    }
  }, [impersonate, router, triggerFeedback, dictionary]);

  React.useEffect(() => {
    if (token) {
      impersonateUser(token);
    } else {
      triggerFeedback({
        severity: 'error',
        message: dictionary.auth.impersonate.noToken,
      });
      router.auth.login.go();
    }
  }, [impersonateUser, router, token, triggerFeedback, dictionary]);

  return <BodyLoading height="100vh"/>;
};
